import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  background: {
    border: '1px solid #D8D8D8',
    borderRadius: theme.shape.borderRadius * 8,
    backgroundColor: '#F6F6F6',
    padding: theme.spacing(6),
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  root: {
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  body: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  calloutContainer: ({ stackCallout }) => ({
    display: 'flex',
    flexDirection: stackCallout ? 'column' : 'row',
    alignItems: stackCallout ? 'stretch' : 'center',
    border: '1px solid rgba(50, 104, 167, 0.22)',
    borderRadius: 12,
    backgroundColor: theme.palette.blue.light100,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    ...(!stackCallout && {
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        borderRadius: 12,
      },
    }),
  }),
  calloutText: ({ stackCallout }) => ({
    flex: stackCallout ? 'none' : 1,
    ...(stackCallout
      ? {}
      : {
        borderRight: '1px solid rgba(50, 104, 167, 0.18)',
        paddingRight: theme.spacing(2),
        marginRight: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
          borderRight: 'none',
          paddingRight: 0,
          marginRight: 0,
        },
      }),
  }),
  optInText: {
    fontSize: '10px',
    textAlign: 'left',
  },
  link: {
    color: '#3268A7',
    textDecoration: 'underline',
  },
  calloutCheckbox: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  checkboxRow: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  checkboxTexts: {
    flex: 1,
  },
  proceedingText: {
    fontSize: '10px',
    textAlign: 'left',
    marginTop: theme.spacing(0.5),
  },
  middleDivider: ({ stackCallout }) => (
    stackCallout
      ? {
        display: 'block',
        height: '1px',
        width: '100%',
        marginTop: theme.spacing(1.5),
        marginBottom: theme.spacing(1.5),
      }
      : {
        display: 'none',
        [theme.breakpoints.down('sm')]: {
          height: '1px',
          width: '100%',
          marginTop: theme.spacing(1),
          marginBottom: theme.spacing(3),
          display: 'block',
        },
      }
  ),
  topSection: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  iconWithDivider: {
    marginRight: theme.spacing(2),
  },
  header: {
    borderLeft: '0.5px solid #D8D8D8',
    paddingLeft: theme.spacing(2),
  },
  checkbox: {
    paddingTop: theme.spacing(0),
    paddingRight: theme.spacing(1.5),
  },
  standardHeader: {
    textAlign: 'left',
    marginBottom: theme.spacing(1),
  },
}))

export default useStyles
